import client from 'client';

import {
    CreateQuestionRequest,
    GetHighlightedRequest,
    GetQnaBySessionRequest,
    QnA,
    QnaSettings,
    QnaSession,
    Question,
    SearchQuestionRequest,
    GetSettingsRequest,
    UpvoteQnaRequest,
    SearchQuestionResponse,
} from './types';

export async function upvote({
    eventId,
    qnaId,
    id,
}: UpvoteQnaRequest): Promise<Record<string, never>> {
    const response = await client().put(
        `/api/v2/qna/events/${eventId}/qnas/${qnaId}/questions/${id}/vote`
    );

    return response.data;
}

export async function cancelUpvote({
    eventId,
    qnaId,
    id,
}: UpvoteQnaRequest): Promise<Record<string, never>> {
    const response = await client().delete(
        `/api/v2/qna/events/${eventId}/qnas/${qnaId}/questions/${id}/vote`
    );

    return response.data;
}

export async function search({
    eventId,
    qnaId,
    criteria,
    orders,
}: SearchQuestionRequest): Promise<SearchQuestionResponse> {
    const response = await client().post(
        `/api/v2/qna/events/${eventId}/qnas/${qnaId}/questions/search`,
        {
            page: 0,
            size: 2500,
            orders: orders || {
                VOTE_COUNT: 'DESC',
            },
            criteria,
        }
    );

    return response.data;
}

export async function getHighlighted({
    eventId,
    qnaId,
}: GetHighlightedRequest): Promise<QnaSettings> {
    const response = await client().get(
        `/api/v2/qna/events/${eventId}/qnas/${qnaId}/questions/highlighted`
    );

    return response.data;
}

export async function getSettings({ eventId, qnaId }: GetSettingsRequest): Promise<QnA> {
    const response = await client().get(`/api/v2/qna/events/${eventId}/qnas/${qnaId}`);

    return response.data;
}

export async function getBySession({
    eventId,
    sessionId,
}: GetQnaBySessionRequest): Promise<QnaSession> {
    const response = await client().get(`/api/v2/qna/events/${eventId}/qnas/session/${sessionId}`);

    return response.data;
}

export async function create({
    qnaId,
    eventId,
    text,
    anonymous,
    user,
}: CreateQuestionRequest): Promise<Question> {
    const userDetails = user && {
        ...user,
        askedBy: user.id,
    };
    const response = await client().post(
        `/api/v2/qna/events/${eventId}/qnas/${qnaId}/questions/submit`,
        {
            text,
            anonymous,
            eventId,
            qnaId,
            ...(user && { userDetails }),
        }
    );

    return response.data;
}
